"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Advantage() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="15887" id="the-metpro-advantage" className="bg-background py-32 md:py-44 text-foreground">
      <div className="mx-auto w-full max-w-[1280px] px-6 md:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {}
          <div ref={leftRef} className="lg:col-span-5" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 700ms cubic-bezier(0.16, 1, 0.3, 1), transform 700ms cubic-bezier(0.16, 1, 0.3, 1)"
        }}>
            <p className="font-default text-[12px] font-medium uppercase mb-8 text-[#4BC545]" style={{
            letterSpacing: "0.14em",
            lineHeight: 1
          }}>
              Our Methodology
            </p>
            <h1 className="font-default font-semibold text-foreground" style={{
            fontSize: "clamp(2.75rem, 5.2vw, 4.75rem)",
            letterSpacing: "-0.02em",
            lineHeight: 1.04
          }}>
              {"A technical "}
              <span className="relative inline-block italic">
                {"advantage"}
                <span aria-hidden="true" className="absolute left-0 right-0 block" style={{
                bottom: "0.08em",
                height: "1px",
                backgroundColor: "var(--accent)",
                transform: leftVisible ? "scaleX(1)" : "scaleX(0)",
                transformOrigin: "left center",
                transition: "transform 600ms cubic-bezier(0.16, 1, 0.3, 1)",
                transitionDelay: leftVisible ? "840ms" : "0ms"
              }} />
              </span>
              {", built for industrial scale."}
            </h1>
          </div>

          {}
          <div ref={rightRef} className="lg:col-span-7" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 700ms cubic-bezier(0.16, 1, 0.3, 1), transform 700ms cubic-bezier(0.16, 1, 0.3, 1)",
          transitionDelay: "200ms"
        }}>
            <div className="max-w-[60ch]">
              <p className="font-default font-normal text-muted-foreground" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.1875rem)",
              letterSpacing: "-0.005em",
              lineHeight: 1.6
            }}><span className="font-default float-left text-primary" data-ast-id="f:/src/pages/Home/sections/Advantage.tsx|sig:xof00z" data-ast-start="3155" data-ast-end="3533" style={{
                fontSize: '4em',
                fontWeight: '600',
                lineHeight: '0.9',
                marginRight: '12px',
                marginTop: '0.08em'
              }}>M</span>etPro Partners was founded on a single premise: that elite manufacturers require a sales agency whose technical fluency matches their own. Our commitment to the manufacturing sectors of our country is encoded in our rigorous approach to market penetration, lead qualification, and long-term account stewardship.</p>

              <p className="font-default font-normal text-muted-foreground mt-6" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.1875rem)",
              letterSpacing: "-0.005em",
              lineHeight: 1.6
            }}>
                Market expansion is not a byproduct of volume; it is the result of precision. We measure our success by the depth of our integration into your sales cycle, ensuring that every interaction we facilitate is backed by industry-aware intelligence. We prioritize high-value, long-cycle partnerships over transient opportunities, operating with the discipline required by serious B2B decision-makers.
              </p>

              <div aria-hidden="true" className="my-10" style={{
              width: "80px",
              height: "1px",
              backgroundColor: "var(--border)"
            }} />

              <p className="font-default font-normal text-muted-foreground" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.1875rem)",
              letterSpacing: "-0.005em",
              lineHeight: 1.6
            }}>
                In practice, this means applying technical rigor to every outreach, providing transparent reporting on pipeline health, and treating your brand as our own. We don't just represent your products; we act as an extension of your engineering and sales teams. The result is a partnership that aligns with how your clients operate: with reliability, technical precision, and a focus on long-term industrial performance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}